import { Collapse, Chip, Step, StepLabel, Stepper, StepIcon, IconButton, Tooltip } from '@mui/material';
import React from 'react';
import PropTypes from 'prop-types';
import SouthIcon from '@mui/icons-material/South';
import NorthIcon from '@mui/icons-material/North';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import ClearIcon from '@mui/icons-material/Clear';
import BlockIcon from '@mui/icons-material/Block';
import AddIcon from '@mui/icons-material/Add';

import { getCoordinatesToLonLat } from '../../../../../../shared/utils/coordinatesFormatting';
import StepperRow from './styles/StepperRow';
import StepperRowMain from './styles/StepperRowMain';
import StepperRowColumn from './styles/StepperRowColumn';
import StepperLabelBox from './styles/StepperLabelBox';
import StepperAddress from './styles/StepperAddress';
import StepperCoords from './styles/StepperCoords';

export default function StepperList({ points, selectedOrdersIds, drawingGeometryId, onClickDraw, onClickDelete }) {
  return (
    <Collapse in={!!selectedOrdersIds?.length}>
      <Stepper orientation="vertical">
        {points?.keys?.map((key) => {
          const geometry = points.values[key];
          const isSelected = selectedOrdersIds?.includes(geometry.orderNumber);
          if (!isSelected) return null;
          const { loadingAddress, deliveryAddress } = geometry?.addresses || {};
          const coordinates = !!geometry.coordinates && getCoordinatesToLonLat(geometry.coordinates);
          return (
            <Step key={geometry.id} active>
              <StepLabel
                icon={
                  geometry.coordinates ? (
                    <StepIcon icon={`${geometry.index}`} sx={{ color: geometry.color }} />
                  ) : (
                    <Tooltip title="Координаты не указаны">
                      <WarningAmberIcon color="warning" />
                    </Tooltip>
                  )
                }
                sx={{ alignItems: 'flex-start' }}
              >
                <StepperRow>
                  <StepperRowMain>
                    <StepperRowColumn>
                      <StepperLabelBox>
                        {geometry.label}
                        {geometry.isLoading && <SouthIcon sx={{ fontSize: '0.9em' }} />}
                        {geometry.isUnloading && <NorthIcon sx={{ fontSize: '0.9em' }} />}
                      </StepperLabelBox>
                      {geometry.isLoading && loadingAddress ? (
                        <StepperAddress>{loadingAddress}</StepperAddress>
                      ) : geometry.isUnloading && deliveryAddress ? (
                        <StepperAddress>{deliveryAddress}</StepperAddress>
                      ) : null}
                      {!!coordinates && <StepperCoords>{coordinates}</StepperCoords>}
                    </StepperRowColumn>
                    <Chip
                      label={`#${geometry.orderNumber}`}
                      size="small"
                      sx={{
                        fontWeight: 'normal',
                        marginTop: '3px',
                      }}
                    />
                  </StepperRowMain>
                  {geometry.coordinates ? (
                    <Tooltip title="Стереть">
                      <span>
                        <IconButton color="primary" size="small" onClick={() => onClickDelete(geometry)}>
                          <ClearIcon fontSize="small" />
                        </IconButton>
                      </span>
                    </Tooltip>
                  ) : drawingGeometryId === geometry.id ? (
                    <Tooltip title="Отмена">
                      <span>
                        <IconButton color="primary" size="small" onClick={() => onClickDraw(null)}>
                          <BlockIcon fontSize="small" />
                        </IconButton>
                      </span>
                    </Tooltip>
                  ) : (
                    <Tooltip title="Указать на карте">
                      <span>
                        <IconButton color="primary" size="small" onClick={() => onClickDraw(geometry.id)}>
                          <AddIcon fontSize="small" />
                        </IconButton>
                      </span>
                    </Tooltip>
                  )}
                </StepperRow>
              </StepLabel>
            </Step>
          );
        })}
      </Stepper>
    </Collapse>
  );
}
StepperList.propTypes = {
  points: PropTypes.shape().isRequired,
  selectedOrdersIds: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])).isRequired,
  drawingGeometryId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onClickDraw: PropTypes.func.isRequired,
  onClickDelete: PropTypes.func.isRequired,
};
